// modules/contact-form-labels.js
export function initContactFormLabels() {
  // Get all form controls (excluding submit button and select)
  const formControls = document.querySelectorAll(
    ".wpcf7-form-control:not(.wpcf7-submit):not(.wpcf7-select)",
  );

  formControls.forEach(function (control) {
    // Find the associated label
    const labelId = control.getAttribute("id");
    const associatedLabel = document.querySelector(
      'label[for="' + labelId + '"]',
    );

    if (associatedLabel) {
      // Show label on focus
      control.addEventListener("focus", function () {
        associatedLabel.classList.add("show");
      });

      // Hide label on blur (when focus is lost)
      control.addEventListener("blur", function () {
        associatedLabel.classList.remove("show");
      });
    }
  });
}
